import {
    type FinanceInsuranceActionsType,
    START_INSURANCE_RATE_FETCH,
    FINISH_INSURANCE_RATE_FETCH,
    CLEAR_INSURANCE_RATE,
    SET_INSURANCE_PERSONALIZED,
    SET_INSURANCE_COLLAPSABLE_ACTIVE,
} from "../actions/FinanceInsuranceActions";
import type { InsuranceRateStateType } from "../../../../shared-logic/types/InsuranceTypes";

export type BuildInsuranceRateStateType = InsuranceRateStateType & {
    collapsableActive: boolean;
};

export const initialState: BuildInsuranceRateStateType = {
    fetching: false,
    error: false,
    total: 0,
    isPersonalizedQuote: false,
    quoteInfo: {},
    info: {
        disclaimer: { value: "" },
    },
    collapsableActive: false,
};

const insuranceRateReducer = (
    state: BuildInsuranceRateStateType = initialState,
    action: FinanceInsuranceActionsType,
): BuildInsuranceRateStateType => {
    switch (action.type) {
        case START_INSURANCE_RATE_FETCH:
            return { ...state, fetching: true, error: false };

        case FINISH_INSURANCE_RATE_FETCH: {
            const { legalText, total, quoteInfo, name } = action.result;
            const info = {
                disclaimer: legalText,
            };

            return { ...state, total, info, name, quoteInfo: quoteInfo || {}, fetching: false };
        }

        case SET_INSURANCE_PERSONALIZED: {
            return { ...state, isPersonalizedQuote: action.isPersonalized };
        }

        case SET_INSURANCE_COLLAPSABLE_ACTIVE:
            return { ...state, collapsableActive: action.active };

        case CLEAR_INSURANCE_RATE:
            return { ...initialState };

        default:
            return state;
    }
};

export default insuranceRateReducer;
